import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import en from '../../assets/i18n/en.json';
import fr from '../../assets/i18n/fr.json';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslateService {
  private languageSubject = new BehaviorSubject<string>('en');
  public language$: Observable<string> = this.languageSubject;

  data: Record<string, string> = {};
  dataApp: Record<string, Record<string, string>> = {};
  currentLanguage: string;

  constructor(
    @Inject(LOCALE_ID) public localeId: string,
    private http: HttpClient,
  ) {
    this.use(localeId.split('-')[0]);
  }
  /**
   * Default: prefix: {string} = '/assets/i18n/', suffix: {string} = '.json'
   */
  use(language: string): void {
    if (language !== this.currentLanguage) {
      this.currentLanguage = language === 'fr' ? 'fr' : 'en';
      // library data from json files i18n
      this.data = this.currentLanguage === 'fr' ? fr : en;

      // Application data from language i18n
      this.extendData(this.dataApp[this.currentLanguage]);
      this.languageSubject.next(this.currentLanguage);
    }
  }
  /**
   * Loading i18n string file from Http
   *
   * Default: prefix: {string} = '/assets/i18n/', suffix: {string} = '.json'
   */
  addHttpTranslation(
    languages: string[],
    prefix: string = '/assets/i18n/',
    suffix: string = '.json',
  ): void {
    languages.forEach((language) => {
      const key = `${prefix}${language}${suffix}`;
      this.http.get<Record<string, string>>(key).subscribe((data) => {
        //      this.data = this.extendList(this.data, data);
        this.dataApp[language] = data;
        this.extendData(this.dataApp[language]);
      });
    });
  }
  /**
   * Loading i18n string file from json files
   */
  addJsonTranslation(languages: Record<string, Record<string, string>>): void {
    if (languages) {
      this.dataApp = languages;
      this.extendData(this.dataApp[this.currentLanguage]);
    }
  }

  private extendData(data: Record<string, string> | undefined): void {
    if (data) {
      this.data = this.extendList(this.data, data);
    }
  }

  private extendList(
    listBase: Record<string, string>,
    listAdded: Record<string, string>,
  ): Record<string, string> {
    for (const key in listAdded) {
      if (Object.prototype.hasOwnProperty.call(listAdded, key)) {
        listBase[key] = listAdded[key];
      }
    }
    return listBase;
  }
}
